import styled from "styled-components";

export const UpcomingEventStyled = styled.div`
  display: flex;
  column-gap: 15px;
  .uc_left_col {
    flex: 0.45;
    .ue_img {
      width: 100%;
      height: auto;
    }
  }
  .uc_right_col {
    flex: 0.55;
    .ue_title {
      margin-bottom: 4px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
    }
    .ue_detail {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
  }
`;
